import type { GrowthCreateGoalRequest, GrowthRecommendation } from '../data-contract/growth';

const escapeHtml = (text: string): string =>
    text.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');

export const recommendationDescription = (recommendation: GrowthRecommendation, trackingLabel: string): string =>
    `${recommendation.description}<p><b>${escapeHtml(trackingLabel)}</b> ${escapeHtml(recommendation.tracking)}</p>`;

export const recommendationDraftOf = (
    recommendation: GrowthRecommendation,
    trackingLabel: string,
): Omit<GrowthCreateGoalRequest, 'share'> => ({
    description: recommendationDescription(recommendation, trackingLabel),
    due: null,
    measure: recommendation.measure,
    paysIntoId: recommendation.paysIntoId,
    suggestionId: recommendation.id,
    title: recommendation.title,
});
